import { render } from "./TabsLineQuestions.vue?vue&type=template&id=3ce28552&scoped=true"
import script from "./TabsLineQuestions.vue?vue&type=script&lang=js"
export * from "./TabsLineQuestions.vue?vue&type=script&lang=js"

import "./TabsLineQuestions.vue?vue&type=style&index=0&id=3ce28552&lang=scss&scoped=true"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ce28552"]])

export default __exports__